import React, { useState, useContext, useEffect } from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import Header from './components/header'
import Process from './components/process'
import Advantage from './components/advantage'
import Superior from './components/superior'
import Operate from './components/operate'

import { IMachineConfig } from './types'
import context from './context'
import { displayRegisteredTips } from './apis'

const FriendTip = (props: { title: string; describe: string }) => {
  const { title, describe } = props
  return (
    <div className={styles.oldFriendTip}>
      <p className={styles.title}>{title}</p>
      <p className={styles.describe}>{describe}</p>
    </div>
  )
}

function ShareBefore(props: IMachineConfig & { isDeriveOutside: boolean }) {
  const { isDeriveOutside } = props
  const { activityType, lang, local, equity, registered } = useContext(context)
  const [showTip, setShowTip] = useState(false)

  useEffect(() => {
    if (isDeriveOutside) {
      displayRegisteredTips({
        countryCode: local,
        language: lang,
        activityType,
      }).then(({ code, data }) => {
        if (code !== 200) {
          return
        }
        setShowTip(data)
      })
    }
  }, [])

  return (
    <div className={classnames(styles.shareBefore, styles[lang], styles[equity])}>
      <Header />
      <Process />
      <Advantage flow="before" {...props} />
      <Superior />
      <Operate share="before" />
      {showTip && <FriendTip {...registered} />}
    </div>
  )
}

export default ShareBefore
